sofistik-language-toggle {
  display: block;
  cursor: pointer;
  border-left: 1px solid #ccc;
  padding-left: 15px;
}
